export const enUSAccounts = {
  loading: 'Loading accounts...',
  errorLoad: 'Failed to load accounts. Please try again.',
  pageTitle: 'Accounts',
  addAccount: 'Add Account',
  noAccounts: 'No accounts yet. Create your first account.',
  modalCreateTitle: 'Create Account',
  modalEditTitle: 'Edit Account',
  deleteTitle: 'Delete Account',
  deleteMessage: 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
  deleteConfirm: 'Delete',
  typeCreditCard: 'Credit Card',
  typeBankAccount: 'Bank Account',
  typeDebitCard: 'Debit Card',
  typeCash: 'Cash',
  formNameLabel: 'Name',
  formNamePlaceholder: 'e.g., Chase Checking',
  formTypeLabel: 'Account Type',
  formSaving: 'Saving...',
  formCreating: 'Creating...',
  formSave: 'Save',
  formCreate: 'Create',
  formError: 'Failed to save account',
  validationNameRequired: 'Name is required',
  validationNameTooLong: 'Name is too long',
  noAccountsTitle: 'No accounts',
  noAccountsMessage: 'Add your bank accounts and credit cards to track payments.',
  formColorLabel: 'Color (optional)',
  formColorPlaceholder: '#FF5733',
  validationColorInvalid: 'Color must be a valid hex color (e.g., #FF5733)',
} as const;
